import EfSpec from '@elem/ui/ef-spec';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import NextGenSwiper from './components/NextGenSwiper';
import NextGenInfo from './components/NextGenInfo';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.NextGen');
    const swiperList = [
        {
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154159924/uk-nextGen-pc1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741071775748/nextGen-pc1.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154222055/uk-nextGen-pad1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741071775220/nextGen-pad1.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154245161/uk-nextGen-h51.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741071775060/nextGen-h51.jpg',
        },
        {
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154351654/uk-nextGen-pc2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741156596401/2_2.png',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154222233/uk-nextGen-pad2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741071775914/nextGen-pad2.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741154245319/uk-nextGen-h52.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741071775426/nextGen-h52.jpg',
        },
    ];
    const infoList = [
        { title: t('item1_title'), desc: t('item1_desc') },
        { title: t('item2_title'), desc: t('item2_desc') },
        { title: t('item3_title'), desc: t('item3_desc') },
        { title: t('item4_title'), desc: t('item4_desc') },
    ];

    return (
        <div className={styles.TheComp} id={PageNavType.Benefit}>
            <EfSpec />
            <div className="ef-NextGen-container">
                <div>
                    <div className="ef-NextGen-title">{t('title')}</div>
                    <div className="ef-NextGen-desc">{t('desc')}</div>
                </div>
                <div className="ef-NextGen-content">
                    <NextGenSwiper className="ef-NextGen-item" list={swiperList} playOptions={{ autoPlay: true }} />
                    <NextGenInfo
                        className="ef-NextGen-item"
                        title={t('info_title')}
                        infoList={infoList}
                        buyNowItem={{
                            href: `https://${locale}.ecoflow.com/products/river-3-plus-portable-power-station`,
                            text: t('buy_now'),
                        }}
                    />
                </div>
            </div>
            <EfSpec />
        </div>
    );
}
